import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    // Button variants
    button: {
        borderRadius: '0.375rem',
        fontFamily: 'eirsans-bold',
        fontWeight: 'inherit',
        textTransform: 'none',
        cursor: 'pointer',
        padding: '0.3rem 3.5rem',
    },
    buttonLarge: { fontSize: '1.125rem', lineHeight: '1.75rem' },
    buttonMedium: { fontSize: '1rem', lineHeight: '1.5rem' },
    buttonSmall: { fontSize: '0.875rem', lineHeight: '1.375rem' },

    // Button Type
    text: {
        padding: 0,
        background: 'none',
        color: theme?.palette?.button?.text?.textColor,
        '&:hover': {
            background: 'transparent',
            color: theme?.palette?.button?.text?.textHoverColor,
        },
    },
    outlined: {
        background: theme?.palette?.button?.outlined?.background,
        border: `0.1875rem solid ${theme?.palette?.button?.outlined?.backgroundHover}`,
        color: theme?.palette?.button?.outlined?.textColor,
        '&:hover': {
            background: theme?.palette?.button?.outlined?.backgroundHover,
            color: theme?.palette?.button?.outlined?.textHoverColor,
            border: `0.1875rem solid ${theme?.palette?.button?.outlined?.backgroundHover}`,
        },
    },
    contained: {
        background: theme?.palette?.button?.contained?.background,
        border: `0.1875rem solid ${theme?.palette?.button?.contained?.background}`,
        color: theme?.palette?.button?.contained?.textColor,
        '&:hover': {
            background: theme?.palette?.button?.contained?.backgroundHover,
            color: theme?.palette?.button?.contained?.textHoverColor,
            border: `0.1875rem solid ${theme?.palette?.button?.contained?.backgroundHover}`,
        },
    },
}));
